<aig-modal class="aig-modal-cancel" position="center" customMaxWidth="600px">
  <div body>
    <div class="u-mt-8 u-px-8">
      <div class="p-flexcc u-dir-col u-gap-30">
        <div class="aig-modal-cancel__logo">
          <img src="../../../../../assets/images/logos/logo.svg" alt="loog-AIG" width="100%" height="auto">
        </div>

        @if (cancelSent == false) {
          <p class="u-color-secondary1 u-fs-20 u-fw-400 u-text-center">
            ¿Desea dar de baja su póliza?
          </p>
          <div class="u-size-per-100 u-ds-flex u-justify-start u-gap-8">
            <input class="aig-contactform__checkbox"
              type="checkbox" name="confirm-cancel" id="confirm-cancel"
              [(ngModel)]="confirmChecked" [checked]="confirmChecked"
            >
            <label class="u-fs-16 u-fw-400 u-color-secondary1" for="confirm-cancel">
              Confirmar baja póliza
            </label>
          </div>
        } @else {
          <p class="u-color-secondary1 u-fs-18 u-fw-400"> Datos guardados con éxito. </p>
        }

        <div></div>
      </div>
    </div>
  </div>
  <div buttons>
    <div class="p-flexcc u-gap-16 u-px-8 u-mb-8">
        @if (cancelSent == false) {
          <button type="button" class="aig-modal-cancel__btn e-btn--secondary p-flexcc" (click)="clickHide(false)">
            Atrás
          </button>
          <button type="button" class="aig-modal-cancel__btn e-btn--primary p-flexcc" [disabled]="confirmChecked == false"
            (click)="sendCancellation()"
          >
            Dar de baja
          </button>
        } @else {
          <button type="button" class="aig-modal-cancel__btn e-btn--primary p-flexcc" (click)="clickHide(true)">
            Aceptar
          </button>
        }
      </div>
  </div>
</aig-modal>
